import { Component, ojs, app, state, v, payload } from "modular-openscriptjs";
import {
  pageInfo,
  inform,
  consoleErrorOnLocal,
  cleanDispose,
  eParse,
  scrollToTop,
  empty,
} from "../../../helpers";
import { api } from "../../../declarations";
import SolidIcon from "../../Blocks/SolidIcon";
import { dom, tool } from "../../../fotastart";
import { $e } from "../../../ojs.events";
import Spinner from "../../Blocks/Spinner";

const h = app("h");
const router = app("router");
const broker = app("broker");

ojs(SolidIcon, Spinner);

export default class ManageStaff extends Component {
  businessId = null;
  staff = state([]);
  invitations = state([]);
  roles = state([]);
  loading = state(true);
  loadingStaff = state(true);
  activeTab = state("active-staff");

  // Suggestions state
  suggestions = state([]);
  loadingSuggestions = state(false);
  showSuggestions = state(false);
  searchTimeout = null;

  $$company = {
    staff: {
      created: () => this.fetchStaffData(),
      deleted: () => this.fetchStaffData(),
      has: {
        creationError: (ed) => this.handleActionError(ed),
        deletionError: (ed) => this.handleActionError(ed),
      },
      invitation: {
        created: () => {
          this.fetchStaffData();
          this.clearInviteForm();
          const btn = dom.id(`send-invitation-${this.id}`);
          if (btn) {
            dom.enable(btn);
            h.span("Send Invitation", { parent: btn, resetParent: true });
            h.SolidIcon("chevron-right", { parent: btn });
          }
        },
        cancelled: () => this.fetchStaffData(),
        has: {
          creationError: (ed) => {
            this.handleActionError(ed);
            const btn = dom.id(`send-invitation-${this.id}`);
            if (btn) {
              dom.enable(btn);
              h.span("Send Invitation", { parent: btn, resetParent: true });
              h.SolidIcon("chevron-right", { parent: btn });
            }
          },
          cancellationError: (ed) => {
            this.handleActionError(ed);
            const { meta } = eParse(ed);
            const btn = dom.id(meta.btnId);
            if (btn) {
              dom.enable(btn);
              h.span("Cancel", { parent: btn, resetParent: true });
              h.SolidIcon("trash", { class: "small", parent: btn });
            }
          },
        },
      },
    },
  };

  render() {
    this.businessId = router.params.companyId;
    scrollToTop()

    return h.div(
      { class: "min-vh-100 py-5 mb-5 py-md-5" },
      h.div(
        { class: "container" },
        // Header
        h.div(
          { class: "mb-5 d-flex align-items-center gap-3" },
          h.button(
            {
              class: "btn btn-white border shadow-sm rounded-circle p-2",
              listeners: {
                click: () => history.back(),
              },
            },
            h.SolidIcon("arrow-left"),
          ),
          h.h2({ class: "fw-bold mb-0" }, "Staff Management"),
        ),

        // Tabs
        h.div(
          { class: "chrome-tabs-wrapper mb-0" },
          this.renderTabTrigger("active-staff", "Active Staff", "people"),
          this.renderTabTrigger("invitations", "Invitations", "envelope-paper"),
        ),

        // Tab Content
        h.div(
          {
            class: "chrome-tab-content bg-white shadow-sm",
            style: "border-radius: 0 0 20px 20px;",
          },
          v(this.activeTab, (tab) => {
            if (tab.value === "active-staff") return this.renderActiveStaffTab();
            if (tab.value === "invitations") return this.renderInvitationsTab();
            return null;
          }),
        ),
      ),
    );
  }

  renderTabTrigger(id, label, icon) {
    return v(this.activeTab, (tab) => {
      return h.button(
        {
          class: `chrome-tab ${tab.value === id ? "active" : ""}`,
          listeners: {
            click: () => (this.activeTab.value = id),
          },
        },
        h.i({ class: `bi bi-${icon} me-2` }),
        label,
      );
    });
  }

  renderActiveStaffTab() {
    if (this.loadingStaff.value) {
      this.fetchStaffData();
    }

    return h.div(
      { class: "py-4" },
      h.h5({ class: "fw-bold mb-4" }, "Current Business Staff"),
      v(this.loadingStaff, (l) => {
        if (l.value) return h.div({ class: "text-center py-5" }, h.Spinner());

        return v(this.staff, (s) => {
          if (empty(s.value)) {
            return h.div(
              {
                class: "text-center py-5 bg-light rounded-4 border-dashed",
                style: "border: 2px dashed #dee2e6;",
              },
              h.div({ class: "text-muted mb-2" }, h.i({ class: "bi bi-people fs-1" })),
              h.p(
                { class: "text-muted mb-0" },
                "No staff members added to the business yet.",
              ),
            );
          }

          return h.div(
            { class: "d-grid gap-3" },
            ...(s.value?.map((member) => this.renderStaffItem(member)) || []),
          );
        });
      }),
    );
  }

  renderInvitationsTab() {
    if (this.loadingStaff.value) {
      this.fetchStaffData();
    }

    return h.div(
      { class: "row g-5 py-4" },
      // Invite Staff Card
      h.div(
        { class: "col-12 col-lg-5" },
        h.div(
          {
            class: "card border-1",
            style: "border-radius: 20px;",
          },
          h.div(
            { class: "card-body p-4 p-md-5" },
            h.h4({ class: "fw-bold mb-4" }, "Invite New Staff"),
            h.p(
              { class: "text-muted small mb-4" },
              "Invite a user to join your business management team.",
            ),

            h.div(
              { class: "mb-4 position-relative" },
              h.label(
                {
                  class: "form-label fw-600 small text-uppercase text-muted mb-1",
                },
                "Username or Email",
              ),
              h.input({
                class: "form-control bg-light border",
                placeholder: "Enter username or email",
                id: "invite-username",
                style: "padding: 0.75rem 1rem;",
                listeners: {
                  input: (e) => this.handleSearchInput(e),
                  focus: () => {
                    if (this.suggestions.value.length > 0)
                      this.showSuggestions.value = true;
                  },
                },
              }),
              // Suggestions Dropdown
              v(this.showSuggestions, (show) => {
                if (!show.value) return null;
                return h.div(
                  {
                    class:
                      "position-absolute w-100 bg-white shadow-lg rounded-4 mt-2 overflow-hidden border",
                    style: "z-index: 1000; top: 100%; left: 0;",
                  },
                  v(this.loadingSuggestions, (loading) => {
                    if (loading.value)
                      return h.div(
                        { class: "p-4 text-center" },
                        h.div({
                          class: "spinner-border spinner-border-sm text-primary",
                        }),
                      );

                    return v(this.suggestions, (sugs) => {
                      if (sugs.value.length === 0)
                        return h.div(
                          { class: "p-4 text-muted small text-center" },
                          "No users found.",
                        );

                      return h.div(
                        { class: "list-group list-group-flush" },
                        ...sugs.value.map((user) =>
                          h.button(
                            {
                              class:
                                "list-group-item list-group-item-action border-0 d-flex align-items-center gap-3 py-3 px-4",
                              listeners: {
                                click: () => this.selectSuggestion(user),
                              },
                            },
                            h.img({
                              src:
                                user.profile_photo_path ||
                                "/assets/images/user-avatar.png",
                              class: "rounded-circle",
                              style: "width: 32px; height: 32px; object-fit: cover;",
                            }),
                            h.div(
                              h.div(
                                { class: "fw-bold text-dark" },
                                user.display_name || user.name,
                              ),
                              h.div(
                                { class: "text-muted small" },
                                `@${user.username}`,
                              ),
                            ),
                          ),
                        ),
                      );
                    });
                  }),
                );
              }),
            ),
            h.div(
              { class: "mb-5" },
              h.label(
                {
                  class: "form-label fw-600 small text-uppercase text-muted mb-1",
                },
                "Assign Business Role",
              ),
              h.select(
                {
                  class: "form-select bg-light border",
                  id: "invite-role",
                  style: "padding: 0.75rem 1rem;",
                },
                h.option({ value: "" }, "Select a business role"),
                v(this.roles, (r) =>
                  r.value.map((role) => h.option({ value: role.name }, role.name)),
                ),
              ),
            ),
            h.button(
              {
                class:
                  "btn btn-primary w-100 rounded-pill py-3 fw-bold d-flex align-items-center justify-content-center gap-2 shadow-sm",
                id: `send-invitation-${this.id}`,
                listeners: {
                  click: (e) => this.sendInvitation(e.target),
                },
              },
              h.span("Send Invitation"),
              h.SolidIcon("chevron-right"),
            ),
          ),
        ),
      ),

      // Pending Invitations List
      h.div(
        { class: "col-12 col-lg-7" },
        h.h5(
          { class: "fw-bold mb-4 d-flex align-items-center gap-2" },
          "Pending Invitations",
          v(this.invitations, (inv) =>
            h.span(
              {
                class: "badge bg-info text-white rounded-pill small",
                style: "font-size: 0.7rem;",
              },
              inv.value.length,
            ),
          ),
        ),
        v(this.invitations, (inv) => {
          if (inv.value.length === 0) {
            return h.div(
              {
                class: "text-center py-5 bg-light rounded-4 border-dashed",
                style: "border: 2px dashed #dee2e6;",
              },
              h.p({ class: "text-muted mb-0" }, "No pending invitations."),
            );
          }
          return h.div(
            { class: "d-grid gap-3" },
            ...inv.value.map((i) => this.renderInvitationItem(i)),
          );
        }),
      ),
    );
  }

  renderInvitationItem(invitation) {
    return h.div(
      { class: "col-12" },
      h.div(
        {
          class: "card border-0 shadow-sm rounded-4 border-start border-info border-4",
          style: "background: #fdfdfd; max-width: 100%; overflow: hidden;",
        },
        h.div(
          { class: "card-body p-4" },
          h.div(
            { class: "d-flex flex-wrap align-items-start justify-content-between gap-3" },
            h.div(
              { class: "flex-grow-1", style: "min-width: 0;" },
              h.div(
                { class: "d-flex flex-wrap align-items-center gap-2 mb-1" },
                h.h6(
                  { class: "fw-bold mb-0 text-dark text-truncate", style: "max-width: 100%;" },
                  invitation.display_name || invitation.email || invitation.username,
                ),
                h.span(
                  {
                    class: "badge bg-light text-info border border-info-subtle rounded-pill fw-normal",
                  },
                  invitation.role,
                ),
              ),
              h.div(
                { class: "text-muted small text-truncate" },
                `@${invitation.username || "unknown"}`,
              ),
              h.div(
                { class: "text-muted small mt-1" },
                h.i({ class: "bi bi-clock-history me-1" }),
                `Expires ${invitation.expires_in}`,
              ),
            ),
            h.button(
              {
                class: "btn btn-outline-danger btn-sm rounded-pill px-3 d-flex align-items-center gap-2 flex-shrink-0",
                id: `cancel-invitation-${this.id}-${invitation.id}`,
                onclick: this.method("cancelInvitation", ["${this}", invitation]),
              },
              h.span("Cancel"),
              h.SolidIcon("trash", { class: "small" }),
            ),
          ),
        ),
      ),
    );
  }

  renderStaffItem(member) {
    return h.div(
      { class: "col-12" },
      h.div(
        { class: "card border-0 shadow-sm rounded-4", style: "max-width: 100%; overflow: hidden;" },
        h.div(
          { class: "card-body p-4 d-flex flex-wrap align-items-center gap-3" },
          h.img({
            src: member.profile_photo_path || "/assets/images/user-avatar.png",
            class: "rounded-circle border flex-shrink-0",
            style: "width: 56px; height: 56px; object-fit: cover;",
          }),
          h.div(
            { class: "flex-grow-1", style: "min-width: 0;" },
            h.h6({ class: "fw-bold mb-1 text-dark text-truncate" }, member.display_name || member.name),
            h.div(
              { class: "d-flex flex-wrap align-items-center gap-2 mt-1" },
              h.p({ class: "text-muted small mb-0 text-truncate" }, `@${member.username}`),
              h.span(
                { class: "badge bg-primary-subtle text-primary rounded-pill fw-normal" },
                "Staff",
              ),
            ),
          ),
          h.button(
            {
              class: "btn btn-outline-danger btn-sm rounded-pill px-3 d-flex align-items-center gap-2 flex-shrink-0",
              listeners: {
                click: () => this.removeStaff(member),
              },
            },
            h.span({ class: "d-none d-sm-inline" }, "Remove Staff"),
            h.SolidIcon("trash", { class: "small" }),
          ),
        ),
      ),
    );
  }

  async fetchStaffData() {
    try {
      const [staffRes, invRes, rolesRes] = await Promise.all([
        api.get(`companies/${this.businessId}/staff`),
        api.get(`companies/${this.businessId}/invitations`),
        api.get(`companies/${this.businessId}/available-roles`),
      ]);

      if (staffRes) this.staff.value = staffRes.data.staff;
      if (invRes) this.invitations.value = invRes.data.invitations;
      if (rolesRes) this.roles.value = rolesRes.data.roles;
    } catch (e) {
      consoleErrorOnLocal(e);
    } finally {
      this.loadingStaff.value = false;
    }
  }


  handleActionError(ed) {
    const { message } = eParse(ed);
    consoleErrorOnLocal(message);
  }

  clearInviteForm() {
    const usernameInput = document.getElementById("invite-username");
    const roleSelect = document.getElementById("invite-role");
    if (usernameInput) usernameInput.value = "";
    if (roleSelect) roleSelect.value = "";
  }

  sendInvitation(btn) {
    const usernameInput = document.getElementById("invite-username");
    const roleSelect = document.getElementById("invite-role");

    const username = usernameInput.value.trim();
    const role = roleSelect.value;

    if (!username) return inform("Please enter a username or email", "warning");
    if (!role) return inform("Please select a role", "warning");

    dom.disable(btn);
    h.Spinner({ parent: btn, resetParent: true });

    broker.send(
      $e.company.staff.invitation.needs.creation,
      payload({
        companyId: this.businessId,
        identifier: username,
        role: role,
      }),
    );
  }

  cancelInvitation(btn, invitation) {
    dom.disable(btn);
    h.SmallSpinner({ parent: btn, resetParent: true });

    broker.send(
      $e.company.staff.invitation.needs.cancellation,
      payload(
        {
          companyId: this.businessId,
          id: invitation.id,
        },
        { btnId: btn.id },
      ),
    );
  }

  removeStaff(member) {
    broker.send(
      $e.company.staff.needs.deletion,
      payload({
        companyId: this.businessId,
        id: member.id,
      }),
    );
  }

  handleSearchInput(e) {
    const query = e.target.value.trim();

    if (this.searchTimeout) clearTimeout(this.searchTimeout);

    if (query.length < 2) {
      this.suggestions.value = [];
      this.showSuggestions.value = false;
      return;
    }

    this.searchTimeout = setTimeout(() => {
      this.fetchSuggestions(query);
    }, 300);
  }

  async fetchSuggestions(query) {
    this.loadingSuggestions.value = true;
    this.showSuggestions.value = true;

    try {
      const res = await api.get("users/search", { q: query });
      if (res) {
        this.suggestions.value = res.data.result.data || [];
      }
    } catch (e) {
      consoleErrorOnLocal(e);
    } finally {
      this.loadingSuggestions.value = false;
    }
  }

  selectSuggestion(user) {
    const input = document.getElementById("invite-username");
    input.value = user.username;
    this.showSuggestions.value = false;
    this.suggestions.value = [];
  }
}

ojs(ManageStaff);
